'use client';

import { useQuery } from '@tanstack/react-query';
import { getLocationPreferences } from '@/app/(users)/[locationId]/(dashboard)/settings/(location)/actions/get-location-preferences';
import type { LocationPreferences } from '@/interface/location-preferences';

export function useLocationPreference(locationId?: string) {
  return useQuery({
    queryKey: ['location-preferences', locationId],
    queryFn: async () => {
      const data = await getLocationPreferences(locationId!);
      return data as (LocationPreferences & { locations?: { id: string; slug: string } }) | null;
    },
    enabled: !!locationId,
  });
}
